import React from "react";
import { Box, Divider, Flex, Heading } from "@chakra-ui/react";
import { AccordionItem, Form, Grid, TextInput } from "components";
import { useCurrentCase } from "duck";
import { useUpdateGeneralAssessment } from "../../duck";
import {
  Left,
  Right,
  BoneAugmentation,
  OralSurgery,
  Orthodontics,
  Periodontics
} from "./components";
import { getDefaultValues, FormValues } from "./duck";

const Treatments: React.FC = () => {
  const generalAssessment = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.generalAssessment
  );
  const defaultValues = getDefaultValues(generalAssessment);
  const onChange = useUpdateGeneralAssessment();

  return (
    <AccordionItem title="Treatments">
      <Flex direction="column">
        <Form<FormValues> defaultValues={defaultValues}>
          <Form.Watcher onChange={onChange} defaultValues={defaultValues} />
          <Box>
            <Heading
              as="h3"
              mb={4}
              color="gray.600"
              fontSize="md"
              fontWeight="semibold"
              lineHeight="base"
            >
              Regional Blocks
            </Heading>

            <Grid
              templateColumns={{
                base: "1fr",
                sm: "repeat(2, 1fr)"
              }}
            >
              <Right />
              <Left />
            </Grid>
          </Box>

          <Divider my={6} h="1px" borderColor="#D0D1D3" />

          <Grid
            templateColumns={{
              base: "1fr",
              sm: "repeat(2, 1fr)"
            }}
          >
            <OralSurgery />
            <Orthodontics />
            <Periodontics />
            <BoneAugmentation />
          </Grid>

          <Divider my={6} h="1px" borderColor="#D0D1D3" />

          <TextInput
            type="text-area"
            name="treatmentAdditionalFindingsCommentsAndNotes"
            label="Additional comments and notes"
            placeholder="Enter additional comments and notes"
          />
        </Form>
      </Flex>
    </AccordionItem>
  );
};

export default Treatments;
